export const KeydriveMenuActionStyle = {

  menuButtonNew: {
    textTransform: 'none',
    backgroundColor: '#22638D',
    height: '38px',
    border: '1px solid #E7E7E7',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 400,
    '&:hover': { backgroundColor: '#2d7fb6' },
    '&:focus': { backgroundColor: '#22638D' },
  },

  menuButtonAction: {
    height: '38px',
    border: '1px solid #22638D',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#22638D',
    backgroundColor: '#ffffff',
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'none',
    '&:hover': { backgroundColor: '#edebe9' },
    '&.Mui-disabled': {
      color: '#22638D',
      borderColor: '#22638D',
      backgroundColor: '#f3f2f1',
      opacity: .4
    },
  },

  menu: {
    border: '1px solid #22638d',
    borderRadius: '4px',
    fontSize: '14px',
    color: '#2D2D2D',
    '& .MuiPaper-root': {
      minWidth: '180px',
      border: '1px solid #22638D',
      borderRadius: '4px',
      padding: 0,
    },
    '& .MuiList-root': {
      padding: 0,
    },
  },

  menuItem: {
    borderBottom: '1px solid #0000001a',
    textAlign: 'left',
    font: '14px / 21px "Segoe UI"',
    letterSpacing: '0.13px',
    height: '40px',
    padding: '8px',
  }

};